<template>
  <div class="animated fadeIn">
    <Forms ref="frmDefault"
      :title="'CADASTRO DE CONFIGURAÇÃO DE REGISTROS DE BOTS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-4">
          <label><small v-if="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-textarea type="text"
                             v-model="form.nome.value"
                            :required="form.nome.required"
                            :state="form.nome.state"
                            :maxlength="form.nome.maxlength"
            ></b-form-textarea>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-if="form.botId.required" class="text-danger">*</small> Bot Id:</label>
          <div class="input-group">
            <b-form-input type="text"
                          v-model="form.botId.value"
                          :size="form.botId.maxlength"
                          :required="form.botId.required"
                          :state="form.botId.state"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-if="form.dataCriacao.required" class="text-danger">*</small> Data criação:</label>
          <div class="input-group">
            <b-form-input type="date"
                          v-model="form.dataCriacao.value"
                          :size="form.dataCriacao.maxlength"
                          :required="form.dataCriacao.required"
                          :state="form.dataCriacao.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import RegistroBotRepository from '@/shared/http/repositories/configurations/registrobot.js'
import RegistroBotModel from '@/shared/models/configurations/registrobotmodel.js'
import RegistroBotForms from './registroBotadd-form.js'

export default {
  name: 'WhatsAppConfigurationsAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: RegistroBotModel,
      form: RegistroBotForms
    }
  },
  methods: {
    onLoad () {
    },
    onClear () {
      this.form.nome.value = ''
      this.form.botId.value = ''
      this.form.dataCriacao.value = ''
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.nome) {
          this.form.nome.value = obj.nome
        }
        if (obj.botId) {
          this.form.botId.value = obj.botId
        }
        if (obj.dataCriacao) {
          this.form.dataCriacao.value = obj.dataCriacao
        }

        loading.pop()
      }
    },

    onCreate () {
      loading.push()
      RegistroBotRepository.Create(this.data)
        .then((response) => {
          console.log(response)
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      if (this.form.nome) {
        this.data.nome = this.form.nome.value
      }
      if (this.form.botId) {
        this.data.botId = this.form.botId.value
      }
      if (this.form.dataCriacao) {
        this.data.dataCriacao = this.form.dataCriacao.value
      }

      RegistroBotRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/registroBot/components/add/registroBotadd.vue